var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowmarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9854_79331)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9854_79331",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9854_79331)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9854_79331",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9854_79331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C5.2785 0 2.25 3.0495 2.25 6.79872C2.25 12.126 8.3655 17.6265 8.62578 17.8575C8.733 17.9527 8.8665 18 9 18C9.1335 18 9.267 17.9528 9.37422 17.8583C9.6345 17.6265 15.75 12.126 15.75 6.79872C15.75 3.0495 12.7215 0 9 0Z",
    fill: "#FFDB1E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9854_79331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowmarker);
export default __webpack_public_path__ + "static/media/yellowmarker.bd576ca58ead3eb82e199409e8aae7ff.svg";
export { ForwardRef as ReactComponent };